<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-head"><strong><a href="#/OEBPS/toc#ilust">LIST OF ILLUSTRATIONS</a></strong></h1>
<h2 class="head2"><strong>1st section</strong></h2>
<p class="illus"><em>Solomon and the Queen of Sheba</em>, Hans Holbein the Younger, c.1534. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)</p>
<p class="illus"><em>The Field of Cloth of Gold</em> (at Hampton Court), artist unknown. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)</p>
<p class="illus">‘The King’ and ‘The Pope’ from <em>The Dance of Death</em>, Hans Holbein, c. 1523–6.</p>
<p class="illus"><em>Henry VIII</em>, c.1537, after Hans Holbein. (Walker Art Gallery, National Museums &amp; Galleries on Merseyside.)</p>
<p class="illus"><em>Thomas Howard, 3rd Duke of Norfolk</em>, 1540, Hans Holbein. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)</p>
<p class="illus"><em>Cardinal Thomas Wolsey</em> as founder of Cardinal (later Christ Church) College, Oxford, Sampson Strong. (Christ Church College, Oxford.)</p>
<p class="illus">Effigy of Bishop Wainfleet in Winchester Cathedral. (The Dean and Chapter of Winchester.)</p>
<p class="illus"><em>Christina of Denmark, Duchess of Milan</em>, 1538, Hans Holbein. (National Gallery, London.)</p>
<h2 class="head2"><strong>2nd section</strong></h2>
<p class="illus"><em>Thomas More</em>, 1527, Hans Holbein. (Copyright The Frick Collection, New York.)</p>
<p class="illus"><em>Henry VIII, King of England</em> (with his daughter Princess Mary and William Somers, the Jester), Hans Holbein. (Hulton Getty.)</p>
<p class="illus"><em>Anne de Clèves, reine d’Angleterre</em>, 1539, Hans Holbein. (Photo RMN.)</p>
<p class="illus"><em>A Lady: Portrait of an Unknown Lady</em> (inscribed Anna Bollein Queen), c.1530, Hans Holbein. (The Royal Collection © 2000, Her Majesty the Queen Elizabeth II.)</p>
<p class="illus"><em>The Light of the World</em>, Hans Holbein.</p>
<p class="illus">German woodcut of the deluge, 1524.</p>
<p class="illus"><em>Thomas Cromwell, 1st Earl of Essex</em>, c.1530, after Hans Holbein. (By courtesy of the National Portrait Gallery, London.)</p>
<p class="illus">Cranmer plucked from the pulpit, 1569. (Bodleian Library, Oxford.)</p>
<p class="illus"><em>Thomas Wriothesley</em>, c.1535, Hans Holbein. (Courtesy of the Musées Nationaux, Paris.)</p>
<p class="illus"><em>Thomas Cranmer</em>, c.1550, artist unknown. (Lambeth Palace.)</p>
<p class="illus">Title page of Coverdale’s Bible, 1535, Hans Holbein. (The British Library.)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ilust.vue?4d6d0094